import Vue from 'vue'
import VueX from 'vuex'
import routes from './config/PageRoutes'

//interceptor
import interceptorsSetup  from './services/interceptors' ;
//store
import {store} from './store.js';
// plugins
import VueRouter from 'vue-router'
import VueBootstrap from 'bootstrap-vue'
import VueNVD3 from 'vue-nvd3'
import VueInsProgressBar from 'vue-ins-progress-bar'
import VueSparkline from 'vue-sparklines'
import Vueditor from '@agametov/vueditor'
import VueHljs from 'vue-hljs'
import VueSweetalert2 from 'vue-sweetalert2'
import VueNotification from 'vue-notification'
import VuePanel from './plugins/panel/'
import VueSelect from 'vue-select'
import VueInputTag from 'vue-input-tag'
import VueSlider from 'vue-slider-component'
import VueGoodTable from 'vue-good-table'
import VueCustomScrollbar from 'vue-custom-scrollbar'

// plugins css
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'nvd3/build/nv.d3.min.css'
import 'vue-hljs/dist/vue-hljs.min.css'
import '@agametov/vueditor/dist/style/vueditor.min.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'ionicons/dist/css/ionicons.min.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-select/dist/vue-select.css'
import 'vue-slider-component/theme/antd.css'

// color admin css
import './assets/css/default/app.min.css'
import './assets/css/default/theme/indigo.min.css'
import './scss/vue.scss'
import 'bootstrap-social/bootstrap-social.css'

import App from './App.vue'

import VeeValidate , { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import './registerServiceWorker'

Vue.use(VeeValidate, {
inject: true,
fieldsBagName: 'veeFields'
});
Validator.localize("es", es);

Vue.use(VueX)
Vue.use(VueRouter)
Vue.use(VueBootstrap)
Vue.use(VueNVD3)
Vue.use(VueSparkline)
Vue.use(Vueditor)
Vue.use(VueHljs)
Vue.use(VueSweetalert2)
Vue.use(VueNotification)
Vue.use(VuePanel)
Vue.use(VueGoodTable)

Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
Vue.component('v-select', VueSelect);
Vue.component('input-tag', VueInputTag)
Vue.component('vue-slider', VueSlider)
Vue.component('vue-custom-scrollbar', VueCustomScrollbar)

const router = new VueRouter({
	routes
})

Vue.filter('mayuscula', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase();
})
interceptorsSetup()
Vue.config.productionTip = false
// Vue.config.devtools = false
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

if (process.env.NODE_ENV==="development") {
  console.log('MODO DESARROLLO');
}else{
  //info.log('MODO PRODUCCION');
}